import React from 'react';
import { PMenuItems, useCurrentUserMenu } from './helpers';
import { MobileMenuItem } from './MobileMenuItem';
import { LinearNavigationTabs } from '../../../common/tabs/LinearTabs/LinearTabs';

export const MobileMenuList: React.FC<PMenuItems> = (props) => {
  const { user, currentPath } = props;
  const { currentList } = useCurrentUserMenu({ user });
  const tabs = currentList.map((item) => {
    return {
      ...item,
      value: item.path,
      label: <MobileMenuItem item={item} key={item.path} />,
    };
  });
  return <LinearNavigationTabs tabs={tabs} currentPath={currentPath} />;
};
